import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"

// Start Stimulus and expose it for debugging.
const application = Application.start()
window.Stimulus = application

// Auto-register every *_controller.js in this directory (and subdirectories).
// The identifier is derived from the filename, e.g.
//   table_filter_controller.js -> "table-filter"
//   choices_controller.js -> "choices"
// Add a new controller by dropping a file here — no manual registration needed.
const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
registerControllers(application, controllers)
